<template>
  <u-tooltip v-if="currentUser.can.recognizeFaces" :prevent="!!text?.length" text="Add a description to use AI Enhance" class="transition-opacity">
    <u-button
      :disabled="!text?.length"
      size="2xs"
      label="AI Enhance"
      :variant="variant"
      :color="color"
      icon="i-ri-sparkling-2-fill"
      @click="aiEnhanceDescription"
      :ui="{
        icon: {
          base: 'text-amber-500',
          size: {
            //'2xs': 'h-4 w-4'
          }
        }
      }"
    />
  </u-tooltip>
</template>

<script setup>
  const props = defineProps({
    text: String,
    modal: Object,
    variant: {
      type: String,
      default: 'solid'
    },
    color: {
      type: String,
      default: 'charcoal'
    },
    openerContext: String
  });

  const sessionStore = useSessionStore();
  const currentUser = computed(() => sessionStore.currentUser);

  const emit = defineEmits(['update:text']);

  async function aiEnhanceDescription() {

    useGtm().trackEvent({
      event: 'core_ui-ai-enhance_open',
      action: 'click',
      category: 'ai',
      value: {
        userId: sessionStore.currentUserId,
        openerContext: props.openerContext
      }
    });

    const updated = await useAIActions().openEnhanceModal({
      text: props.text
    });
    if (updated) {
      emit('update:text', updated);
    }
  }
</script>
